import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService, NbCardModule, NbIconModule, NbButtonModule, NbInputModule } from '@nebular/theme';
import { Subject, takeUntil } from 'rxjs';
import { WebSocketService } from 'src/app/core/services/web-socket.service';
import { CampaignService } from '../../services/campaign.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-campaign-terminate-modal',
    templateUrl: './campaign-terminate-modal.component.html',
    styleUrls: ['./campaign-terminate-modal.component.css'],
    imports: [NbCardModule, NbIconModule, NbButtonModule, NbInputModule, FormsModule]
})
export class CampaignTerminateModalComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();

  public reasonText = '';
  public campaign;

  constructor(
    protected ref: NbDialogRef<CampaignTerminateModalComponent>,
    private service: CampaignService,
    private socketService: WebSocketService,
    private toastrService: NbToastrService
  ) {}

  public ngOnInit() {}

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public terminate() {
    if (this.campaign.batch_job_id) {
      this.service
        .terminateCampaignJob(null, this.reasonText)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if (data.message === 'successful') {
            this.socketService.closeWindow(data.job_id);
            this.ref.close(true);
          } else {
            this.toastrService.show(
              status,
              $localize`Terminating Campaign: ${this.campaign.name}'s Job: ${this.campaign.batch_job_id} Failed`,
              {
                status: 'danger'
              }
            );
          }
        });
    } else {
      this.toastrService.show(status, $localize`Could not find Job ID, try refreshing the Campaigns Table.`, {
        status: 'danger'
      });
    }
  }

  public close() {
    this.ref.close(false);
  }
}
